import React from 'react'
import { Formik, Field } from 'formik'

// Components
import InputText from '../FormInputs/InputText'
import Button from '../Button'

// validations
import { email, required } from '../FormInputs/helperFunctions'


const NewsletterForm = (props) => {
  const { updateState, checked } = props
  return (
    <Formik
      onSubmit={(values, actions) => {


        fetch('https://h1v2zr8pi6.execute-api.ap-south-1.amazonaws.com/prod', {
          method: 'POST', // or 'PUT'
          body: JSON.stringify({
            name: values.name,
            email: values.email
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            window.location.reload(false)
            alert('Thank you for subscribing.');
          })
          .catch((error) => {
            window.location.reload(false)
            alert('Something went wrong. Please try again later');
          });

      }}
      render={(props) => {
        return (
          <form onSubmit={props.handleSubmit}>
            <div className="flex">
              <div style={{ flex: '1' }}>
                <div className="c-padd">
                  <Field
                    validate={required}
                    name="name"
                    component={InputText}
                    type="text"
                    placeholder="Name"
                  />
                </div>
                {(props.touched.name || props.errors.name) && <label className="e-label error">{props.errors.name}</label>}
              </div>

              <div style={{ flex: '1' }}>
                <div className="c-padd">
                  <Field
                    validate={email}
                    name="email"
                    component={InputText}
                    type="email"
                    placeholder="Email"
                  />
                </div>
                {(props.touched.email || props.errors.email) && <label className="e-label error">{props.errors.email}</label>}
              </div>
            </div>

            <div className="c-padd">
              <label className="checkbox-parent link-fs" style={{ textAlign: 'justify', marginLeft: '1.5rem' }}>
                <input
                  style={{ marginRight: '0.4rem' }}
                  type="checkbox"
                  checked={checked}
                  onChange={() => updateState({ 'checked': !checked })} />
                Yes, I hereby agree that my personal data provided by me may be processed by EIDIM Group, Inc dba EIDIM AV Technology (“EIDIM”). The purpose of the processing is the sending of e-mails by EIDIM to the e-mail address I have provided above in order to receive information about the services, news, current offers, campaigns, and events. My personal data will not be passed on to third parties. I can withdraw my consent any time by clicking the unsubscribed button link provided in the newsletter or by e-mail at <a href="mailto:contact@eidim.com">contact@eidim.com</a>.
                <span className="checkmark"></span>
              </label>
            </div>


            <div className="subscribe-btn h-padd">
              <Button
                title="Subscribe"
                type="submit"
                disabled={!checked}
              />
            </div>
          </form >
        )
      }}
    />
  )
}

export default NewsletterForm